import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';

export const networkGetProjectInfo = async (projectId) => {
  const res = await axiosInstance.post(`Application/Info/${projectId}`);
  return res;
};

export function useFetchProjectInfo(projectId) {
  return useQuery({
    queryKey: ['project-info', projectId],
    queryFn: () => networkGetProjectInfo(projectId),
  });
}

export const networkCreateProject = async (data) => {
  const res = await axiosInstance.post('Application/Create', data);
  return res;
};

export const networkEditProject = async (project_id, data) => {
  const res = await axiosInstance.post(`Application/Update/${project_id}`, data);
  return res;
};

export const networkGetProjectList = async (pageIndex = 0, pageSize = 50) => {
  // const res = await axiosInstance.post(`Application/List/${pageIndex}/${pageSize}/`);
  const res = await axiosInstance.post('Application/List');
  return res;
};

export function useFetchProjectList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    // queryKey: ['project-list', pageIndex],
    queryKey: ['project-list'],
    queryFn: () => networkGetProjectList(pageIndex, pageSize),
  });
}

//
export const networkGetProjectSearchList = async (payload) => {
  // const res = await axiosInstance.post(`Application/List/${pageIndex}/${pageSize}/`);
  const res = await axiosInstance.post('Application/ListBySearch', payload);
  return res;
};

export function useFetchProjectSearchList(payload) {
  return useQuery({
    // queryKey: ['project-list', pageIndex],
    queryKey: ['project-list-search'],
    queryFn: () => networkGetProjectSearchList(payload),
  });
}
//

export const networkGetProjectFeedList = async (projectId, appSectionKeyOrder) => {
  const res = await axiosInstance.post(`Feed/Group/List/${projectId}/${appSectionKeyOrder}`);
  return res;
};

export function useFetchProjectFeedList(projectId, appSectionKeyOrder) {
  return useQuery({
    queryKey: ['project-feed-list', projectId, appSectionKeyOrder],
    queryFn: () => networkGetProjectFeedList(projectId, appSectionKeyOrder),
  });
}

export const networkGetProjectDomain = async (body) => {
  if (body) {
    const res = await axiosInstance.post(`ApplicationDomain/List/0/200`, body);
    return res?.data;
  }
};

export function useFetchProjectDomain(body) {
  return useQuery({
    queryKey: ['project-domain'],
    queryFn: () => networkGetProjectDomain(body),
  });
}

export const networkGetProjectDomainInsert = async (data) => {
  const res = await axiosInstance.post(`ApplicationDomain/Insert`, data);
  return res;
};

export const networkGetProjectDomainUpdate = async (id, data) => {
  const res = await axiosInstance.post(`ApplicationDomain/Update/${id}`, data);
  return res;
};

export const networkGetProjectDomainDelete = async (id) => {
  const res = await axiosInstance.post(`ApplicationDomain/Remove/${id}`);
  return res;
};
